<template>
  <a-modal
    :keyboard="false"
    :maskClosable="false"
    :visible="visible"
    :title="$t('现金流量分配')"
    :width="760"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <div class="flex-ct mb10" style="justify-content: space-between">
      <span class="text-disabled">{{ $t('已分配合计') }}: {{ totalAmount }} {{ currency }}</span>
      <a-button type="link" size="small" @click="addLine">{{ $t('新增') }}</a-button>
    </div>
    <CommonTable
      :dataSource="list"
      :columns="columns"
      :pagination="false"
      rowKey="key"
      :showPagination="false"
      size="small"
      :scroll="{ y: 400 }"
    >
      <template v-slot:cashFlowItemCode="{ record }">
        <CommonQuerySelect
          api="getCashFlowItemList"
          :code.sync="record.cashFlowItemCode"
          :name.sync="record.cashFlowItemName"
          :init="true"
          :placeholder="$t('请选择现金流量项目')"
        />
      </template>
      <template v-slot:amount="{ record }">
        <PriceInput
          :value.sync="record.amount"
          :currency="currency"
          :placeholder="$t('请输入金额')"
        />
      </template>
      <template v-slot:operation="{ record }">
        <a class="text-danger" @click="deleteLine(record)">{{ $t('删除') }}</a>
      </template>
    </CommonTable>
  </a-modal>
</template>

<script>
import { add } from '@/common/number'
import CommonQuerySelect from '@component/commonQuerySelect'
import PriceInput from '@component/priceInput'
export default {
  name: 'SelectCashFlowItemModal',
  components: { CommonQuerySelect, PriceInput },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    dataSource: {
      type: Array,
      default: () => [],
    },
    // 默认分配金额（一般传明细行金额）
    amount: {},
    currency: {
      type: String,
      default: 'CNY',
    },
  },
  data() {
    return {
      list: [],
      keyNum: 0,
      confirmLoading: false,
    }
  },
  computed: {
    totalAmount() {
      return this.list.reduce((total, item) => add(total, item.amount || 0), 0)
    },
    columns() {
      return [
        {
          title: this.$t('现金流量项目'),
          dataIndex: 'cashFlowItemCode',
          scopedSlots: { customRender: 'cashFlowItemCode' },
          width: 340,
        },
        {
          title: this.$t('金额'),
          dataIndex: 'amount',
          scopedSlots: { customRender: 'amount' },
          width: 220,
        },
        {
          title: this.$t('操作'),
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          width: 80,
        },
      ]
    },
  },
  watch: {
    visible(val) {
      if (val) {
        this.list = (this.dataSource || []).map((item, index) => ({
          key: index + 1,
          cashFlowItemCode: item.cashFlowItemCode,
          cashFlowItemName: item.cashFlowItemName,
          amount: item.amount,
        }))
        this.keyNum = this.list.length
        if (this.list.length === 0) {
          this.addLine()
        }
      }
    },
  },
  methods: {
    addLine() {
      this.keyNum = this.keyNum + 1
      this.list.push({
        key: this.keyNum,
        cashFlowItemCode: undefined,
        cashFlowItemName: undefined,
        amount: this.amount ?? '',
      })
    },
    deleteLine(record) {
      this.list = this.list.filter((item) => item.key !== record.key)
    },
    handleOk() {
      const list = this.list.filter((item) => item.cashFlowItemCode)
      // 未选择任何现金流量项目时直接允许提交
      if (list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          const item = list[i]
          if (!item.amount && item.amount !== 0) {
            this.$message.warning(this.$t('第') + (i + 1) + this.$t('行金额必填'))
            return
          }
        }
        const expected = add(this.amount || 0, 0)
        const actual = list.reduce((total, item) => add(total, item.amount || 0), 0)
        if (actual !== expected) {
          this.$message.warning(
            this.$t('现金流量分配金额合计') + actual + this.$t('必须等于明细金额') + expected
          )
          return
        }
      }
      this.$emit(
        'ok',
        list.map((item) => ({
          cashFlowItemCode: item.cashFlowItemCode,
          cashFlowItemName: item.cashFlowItemName,
          amount: item.amount,
        }))
      )
    },
    handleCancel() {
      this.$emit('update:visible', false)
    },
  },
}
</script>

<style scoped></style>
